import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// A anon key NAO e segredo (vai no bundle por design, ver .env.example na raiz
// do repo). Quem protege o dado e a RLS do backend, nao o sigilo desta chave.
if (!supabaseUrl || !supabaseAnonKey) {
  console.error(
    "VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY ausentes. Copie .env.example " +
      "para .env.local na raiz do repo e preencha com os dados do projeto " +
      "Supabase (docs/backend-setup.md).",
  );
}

// NOTA: nao ha projeto Supabase real ainda (ver docs/backend-setup.md), entao
// nao existem tipos gerados por `supabase gen types typescript`. Os tipos de
// dominio usados pelo front vivem em `src/lib/types.ts`, escritos a mao a
// partir das migrations em supabase/migrations/. Quando o projeto real
// existir, rodar `supabase gen types typescript --project-id <ref>` e trocar
// para `createClient<Database>(...)` da mais seguranca de tipos do que a
// leitura manual do SQL — mas exigiria adivinhar a forma exata que o
// PostgREST gera, sem um projeto real para validar contra. Cada query faz um
// cast explicito (`as unknown as T`) para o tipo de dominio correspondente.
export const supabase = createClient(
  supabaseUrl ?? "https://placeholder.supabase.co",
  supabaseAnonKey ?? "placeholder-anon-key",
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);

export const supabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);
